export const GET_SESSION_SUCCESS = "@@tosca-session/GET_SESSION_SUCCESS";
export const GET_SESSION_ERROR = "@@tosca-session/GET_SESSION_ERROR";
export const GET_USER_SESSION_SUCCESS =
  "@@tosca-session/GET_USER_SESSION_SUCCESS";
export const GET_USER_SESSION_ERROR = "@@tosca-session/GET_USER_SESSION_ERROR";
export const INVALID_SESSION = "@@tosca-session/INVALID_SESSION";
